module.exports = "/lucky-balls/img/bigball/BigBall_022.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_022.png
// module id = 917
// module chunks = 0